export const ZERO_GUID = '00000000-0000-0000-0000-000000000000';
